// Supabase service for HKDSE Category Quiz Data
// Replaces hkdseCategoryQuizData.js imports

import { querySupabase } from '../supabaseClient';

/**
 * Get category quiz data by text ID
 */
export const getCategoryQuizData = async (textId) => {
  try {
    const records = await querySupabase('chi_hkdsecategoryquiz', { text_id: textId }, {
      order_by: 'quiz_category_type',
      order_direction: 'asc'
    });
    
    if (!records || records.length === 0) return null;
    
    // Group by quiz_category_type
    const categoryMap = {};
    records.forEach(record => {
      const categoryType = record.quiz_category_type;
      if (!categoryMap[categoryType]) {
        categoryMap[categoryType] = {
          id: record.quiz_id,
          title: record.quiz_title,
          description: record.quiz_description,
          category: record.quiz_category,
          difficulty: record.quiz_difficulty,
          timeLimit: record.quiz_time_limit,
          questions: []
        };
      }
      categoryMap[categoryType].questions.push({
        id: record.question_id,
        question: record.question_text,
        type: record.question_type,
        options: record.question_options || [],
        correct: record.question_correct_answer,
        explanation: record.question_explanation,
        points: record.question_points
      });
    });
    
    // Transform to component-friendly format
    const firstRecord = records[0];
    return {
      id: firstRecord.text_id,
      title: firstRecord.text_title,
      author: firstRecord.text_author,
      dynasty: firstRecord.text_dynasty,
      category: firstRecord.text_category,
      categoryQuizzes: categoryMap
    };
  } catch (error) {
    console.error('Error fetching category quiz data:', error);
    return null;
  }
};

/**
 * Get category quiz by type
 */
export const getCategoryQuizByType = async (textId, categoryType) => {
  try {
    const records = await querySupabase('chi_hkdsecategoryquiz', {
      text_id: textId,
      quiz_category_type: categoryType
    }, {
      order_by: 'question_id',
      order_direction: 'asc'
    });
    
    if (!records || records.length === 0) return null;
    
    const firstRecord = records[0];
    const questions = records.map(record => ({
      id: record.question_id,
      question: record.question_text,
      type: record.question_type,
      options: record.question_options || [],
      correct: record.question_correct_answer,
      explanation: record.question_explanation,
      points: record.question_points
    }));
    
    return {
      id: firstRecord.quiz_id,
      title: firstRecord.quiz_title,
      description: firstRecord.quiz_description,
      category: firstRecord.quiz_category,
      difficulty: firstRecord.quiz_difficulty,
      timeLimit: firstRecord.quiz_time_limit,
      questions
    };
  } catch (error) {
    console.error('Error fetching category quiz by type:', error);
    return null;
  }
};

/**
 * Get all category quiz data
 */
export const getAllCategoryQuizData = async () => {
  try {
    const records = await querySupabase('chi_hkdsecategoryquiz', {}, {
      order_by: 'text_id',
      order_direction: 'asc'
    });
    
    if (!records || records.length === 0) return {};
    
    // Group by text_id and then by quiz_category_type
    const textMap = {};
    records.forEach(record => {
      if (!textMap[record.text_id]) {
        textMap[record.text_id] = {
          id: record.text_id,
          title: record.text_title,
          author: record.text_author,
          dynasty: record.text_dynasty,
          category: record.text_category,
          categoryQuizzes: {}
        };
      }
      
      const categoryType = record.quiz_category_type;
      if (!textMap[record.text_id].categoryQuizzes[categoryType]) {
        textMap[record.text_id].categoryQuizzes[categoryType] = {
          id: record.quiz_id,
          title: record.quiz_title,
          description: record.quiz_description,
          category: record.quiz_category,
          difficulty: record.quiz_difficulty,
          timeLimit: record.quiz_time_limit,
          questions: []
        };
      }
      
      textMap[record.text_id].categoryQuizzes[categoryType].questions.push({
        id: record.question_id,
        question: record.question_text,
        type: record.question_type,
        options: record.question_options || [],
        correct: record.question_correct_answer,
        explanation: record.question_explanation,
        points: record.question_points
      });
    });
    
    return textMap;
  } catch (error) {
    console.error('Error fetching all category quiz data:', error);
    return {};
  }
};

